import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dgkt7t7qa8: FaireBrandEntity = {
  token: "b_dgkt7t7qa8",
  type: "brand",
  name: "Pistakio",
  avatarUrl:
    "https://cdn.faire.com/fastly/5c019a871bc55ff5284338d83ab7ea71041c0cb7aca699ddaa15815976affbd2.webp",
  bannerUrl:
    "https://cdn.faire.com/fastly/8c6ea397606063124040fd95e4672855991cef139e1340b20375e454bda315ff.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5c019a871bc55ff5284338d83ab7ea71041c0cb7aca699ddaa15815976affbd2.webp",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8c6ea397606063124040fd95e4672855991cef139e1340b20375e454bda315ff.jpeg",
  location: "Portland, OR, USA",
  minimumOrderDollars: 114,
  rating: 4.9,
  reviewCount: 56,
  isInsider: true,
  description:
    "Italian-founded & inspired, Nico & Fran started Pistakio out of their college dorm after struggling to find pistachio products in the US that actually tasted like pistachios. We’re on a mission to reimagine pistachios beyond snacking, by creating flavor-first pistachio products that are fun and easy-to-use, turning this premium ingredient into a go-to pantry staple for pistachio lovers like us.",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:18:06.994Z",
    importedBy: "entity-db-cli",
  },
};
